
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TypographyComponent } from '../typography/typography.component'

@Component({
  selector: 'hyperkit-dropdown-menu-section-header',
  templateUrl: './dropdown-menu-section-header.component.html',
  styleUrls: ['./dropdown-menu-section-header.component.scss'],
  standalone: true,
  imports: [TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuSectionHeaderComponent {
  @Input() label?: string
}
